import React from "react";
import "./SelectableCard.scss";

export interface SelectableCardProps {
  selected?: boolean;
  /**
   * When true, a multi-select session is in progress on the surrounding grid.
   * Selection chrome stays visible on every card and the per-card actions menu
   * is hidden so the user is steered toward checkbox-only interaction.
   */
  selectMode?: boolean;
  selectionSlot?: React.ReactNode;
  actionsSlot?: React.ReactNode;
  mediaSlot: React.ReactNode;
  footerSlot?: React.ReactNode;
  /** Adjacent siblings (e.g. modals/portals) rendered inside the same <li>. */
  children?: React.ReactNode;
  onMediaClick?: () => void;
  className?: string;
}

export default function SelectableCard({
  selected,
  selectMode,
  selectionSlot,
  actionsSlot,
  mediaSlot,
  footerSlot,
  children,
  onMediaClick,
  className = "",
}: SelectableCardProps) {
  const classes = ["selectable-card"];
  if (selected) classes.push("is-selected");
  if (selectMode) classes.push("is-select-mode");
  if (className) classes.push(className);

  return (
    <li className={classes.join(" ")}>
      {selectionSlot && (
        <div className="selectable-card-selection" onClick={(e) => e.stopPropagation()}>
          {selectionSlot}
        </div>
      )}
      {actionsSlot && (
        <div className="selectable-card-actions" onClick={(e) => e.stopPropagation()}>
          {actionsSlot}
        </div>
      )}
      <div
        className="selectable-card-media"
        role={onMediaClick ? "button" : undefined}
        tabIndex={onMediaClick ? 0 : undefined}
        onClick={onMediaClick}
      >
        {mediaSlot}
      </div>
      {footerSlot && <div className="selectable-card-footer">{footerSlot}</div>}
      {children}
    </li>
  );
}
